const Chat = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7A2.5 2.5 0 0 1 7 4.5h10A2.5 2.5 0 0 1 19.5 7v8a2.5 2.5 0 0 1-2.5 2.5H7.48a.5.5 0 0 0-.39.188l-1.254 1.568c-.443.553-1.336.24-1.336-.469zM7 5.5A1.5 1.5 0 0 0 5.5 7v11.075l.81-1.012a1.5 1.5 0 0 1 1.17-.563H17a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 17 5.5z"
      clipRule="evenodd"
    />
  </>
)
export default Chat
